/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Dropfile_Uploading1Inputs */

const en_subscription_dropfile_uploading1 = /** @type {(inputs: Subscription_Dropfile_Uploading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading file...`)
};

/**
* | output |
* | --- |
* | "Uploading file..." |
*
* @param {Subscription_Dropfile_Uploading1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const subscription_dropfile_uploading1 = /** @type {((inputs?: Subscription_Dropfile_Uploading1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Dropfile_Uploading1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_subscription_dropfile_uploading1(inputs)
});
export { subscription_dropfile_uploading1 as "subscription_dropFile_uploading" }